"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var conversions = require("webidl-conversions");
var utils = require("./utils.js");
var Blob = require("./Blob.js");
var EventHandlerNonNull = require("./EventHandlerNonNull.js");
var BinaryType = require("./BinaryType.js");
var implSymbol = utils.implSymbol;
var ctorRegistrySymbol = utils.ctorRegistrySymbol;
var EventTarget = require("./EventTarget.js");
var interfaceName = "WebSocket";
exports.is = function (value) {
  return utils.isObject(value) && utils.hasOwn(value, implSymbol) && value[implSymbol] instanceof Impl.implementation;
};
exports.isImpl = function (value) {
  return utils.isObject(value) && value instanceof Impl.implementation;
};
exports.convert = function (globalObject, value) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$context = _ref.context,
    context = _ref$context === void 0 ? "The provided value" : _ref$context;
  if (exports.is(value)) {
    return utils.implForWrapper(value);
  }
  throw new globalObject.TypeError("".concat(context, " is not of type 'WebSocket'."));
};
function makeWrapper(globalObject, newTarget) {
  var proto;
  if (newTarget !== undefined) {
    proto = newTarget.prototype;
  }
  if (!utils.isObject(proto)) {
    proto = globalObject[ctorRegistrySymbol]["WebSocket"].prototype;
  }
  return Object.create(proto);
}
exports.create = function (globalObject, constructorArgs, privateData) {
  var wrapper = makeWrapper(globalObject);
  return exports.setup(wrapper, globalObject, constructorArgs, privateData);
};
exports.createImpl = function (globalObject, constructorArgs, privateData) {
  var wrapper = exports.create(globalObject, constructorArgs, privateData);
  return utils.implForWrapper(wrapper);
};
exports._internalSetup = function (wrapper, globalObject) {
  EventTarget._internalSetup(wrapper, globalObject);
};
exports.setup = function (wrapper, globalObject) {
  var constructorArgs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var privateData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  privateData.wrapper = wrapper;
  exports._internalSetup(wrapper, globalObject);
  Object.defineProperty(wrapper, implSymbol, {
    value: new Impl.implementation(globalObject, constructorArgs, privateData),
    configurable: true
  });
  wrapper[implSymbol][utils.wrapperSymbol] = wrapper;
  if (Impl.init) {
    Impl.init(wrapper[implSymbol]);
  }
  return wrapper;
};
exports["new"] = function (globalObject, newTarget) {
  var wrapper = makeWrapper(globalObject, newTarget);
  exports._internalSetup(wrapper, globalObject);
  Object.defineProperty(wrapper, implSymbol, {
    value: Object.create(Impl.implementation.prototype),
    configurable: true
  });
  wrapper[implSymbol][utils.wrapperSymbol] = wrapper;
  if (Impl.init) {
    Impl.init(wrapper[implSymbol]);
  }
  return wrapper[implSymbol];
};
var exposed = new Set(["Window", "Worker"]);
exports.install = function (globalObject, globalNames) {
  var _Object$definePropert;
  if (!globalNames.some(function (globalName) {
    return exposed.has(globalName);
  })) {
    return;
  }
  var ctorRegistry = utils.initCtorRegistry(globalObject);
  var WebSocket = /*#__PURE__*/function (_globalObject$EventTa) {
    _inherits(WebSocket, _globalObject$EventTa);
    var _super = _createSuper(WebSocket);
    function WebSocket(url) {
      var _this;
      _classCallCheck(this, WebSocket);
      if (arguments.length < 1) {
        throw new globalObject.TypeError("Failed to construct 'WebSocket': 1 argument required, but only ".concat(arguments.length, " present."));
      }
      var args = [];
      {
        var curArg = arguments[0];
        curArg = conversions["USVString"](curArg, {
          context: "Failed to construct 'WebSocket': parameter 1",
          globals: globalObject
        });
        args.push(curArg);
      }
      {
        var _curArg = arguments[1];
        if (_curArg !== undefined) {
          if (utils.isObject(_curArg)) {
            if (_curArg[Symbol.iterator] !== undefined) {
              if (!utils.isObject(_curArg)) {
                throw new globalObject.TypeError("Failed to construct 'WebSocket': parameter 2" + " sequence" + " is not an iterable object.");
              } else {
                var V = [];
                var tmp = _curArg;
                var _iterator = _createForOfIteratorHelper(tmp),
                  _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var nextItem = _step.value;
                    nextItem = conversions["DOMString"](nextItem, {
                      context: "Failed to construct 'WebSocket': parameter 2" + " sequence" + "'s element",
                      globals: globalObject
                    });
                    V.push(nextItem);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                _curArg = V;
              }
            } else {}
          } else {
            _curArg = conversions["DOMString"](_curArg, {
              context: "Failed to construct 'WebSocket': parameter 2",
              globals: globalObject
            });
          }
        } else {
          _curArg = [];
        }
        args.push(_curArg);
      }
      return _possibleConstructorReturn(_this, exports.setup(Object.create((this instanceof WebSocket ? this.constructor : void 0).prototype), globalObject, args));
    }
    _createClass(WebSocket, [{
      key: "close",
      value: function close() {
        var _esValue$implSymbol;
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'close' called on an object that is not a valid instance of WebSocket.");
        }
        var args = [];
        {
          var curArg = arguments[0];
          if (curArg !== undefined) {
            curArg = conversions["unsigned short"](curArg, {
              context: "Failed to execute 'close' on 'WebSocket': parameter 1",
              globals: globalObject,
              clamp: true
            });
          }
          args.push(curArg);
        }
        {
          var _curArg2 = arguments[1];
          if (_curArg2 !== undefined) {
            _curArg2 = conversions["USVString"](_curArg2, {
              context: "Failed to execute 'close' on 'WebSocket': parameter 2",
              globals: globalObject
            });
          }
          args.push(_curArg2);
        }
        return (_esValue$implSymbol = esValue[implSymbol]).close.apply(_esValue$implSymbol, args);
      }
    }, {
      key: "send",
      value: function send(data) {
        var _esValue$implSymbol2;
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'send' called on an object that is not a valid instance of WebSocket.");
        }
        if (arguments.length < 1) {
          throw new globalObject.TypeError("Failed to execute 'send' on 'WebSocket': 1 argument required, but only ".concat(arguments.length, " present."));
        }
        var args = [];
        {
          var curArg = arguments[0];
          if (Blob.is(curArg)) {
            {
              var _curArg3 = arguments[0];
              _curArg3 = Blob.convert(globalObject, _curArg3, {
                context: "Failed to execute 'send' on 'WebSocket': parameter 1"
              });
              args.push(_curArg3);
            }
          } else if (utils.isArrayBuffer(curArg)) {
            {
              var _curArg4 = arguments[0];
              _curArg4 = conversions["ArrayBuffer"](_curArg4, {
                context: "Failed to execute 'send' on 'WebSocket': parameter 1",
                globals: globalObject
              });
              args.push(_curArg4);
            }
          } else if (ArrayBuffer.isView(curArg)) {
            {
              var _curArg5 = arguments[0];
              if (ArrayBuffer.isView(_curArg5)) {} else {
                throw new globalObject.TypeError("Failed to execute 'send' on 'WebSocket': parameter 1" + " is not of any supported type.");
              }
              args.push(_curArg5);
            }
          } else {
            {
              var _curArg6 = arguments[0];
              _curArg6 = conversions["USVString"](_curArg6, {
                context: "Failed to execute 'send' on 'WebSocket': parameter 1",
                globals: globalObject
              });
              args.push(_curArg6);
            }
          }
        }
        return (_esValue$implSymbol2 = esValue[implSymbol]).send.apply(_esValue$implSymbol2, args);
      }
    }, {
      key: "url",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'get url' called on an object that is not a valid instance of WebSocket.");
        }
        return esValue[implSymbol]["url"];
      }
    }, {
      key: "readyState",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'get readyState' called on an object that is not a valid instance of WebSocket.");
        }
        return esValue[implSymbol]["readyState"];
      }
    }, {
      key: "bufferedAmount",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'get bufferedAmount' called on an object that is not a valid instance of WebSocket.");
        }
        return esValue[implSymbol]["bufferedAmount"];
      }
    }, {
      key: "onopen",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'get onopen' called on an object that is not a valid instance of WebSocket.");
        }
        return utils.tryWrapperForImpl(esValue[implSymbol]["onopen"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'set onopen' called on an object that is not a valid instance of WebSocket.");
        }
        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(globalObject, V, {
            context: "Failed to set the 'onopen' property on 'WebSocket': The provided value"
          });
        }
        esValue[implSymbol]["onopen"] = V;
      }
    }, {
      key: "onerror",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'get onerror' called on an object that is not a valid instance of WebSocket.");
        }
        return utils.tryWrapperForImpl(esValue[implSymbol]["onerror"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'set onerror' called on an object that is not a valid instance of WebSocket.");
        }
        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(globalObject, V, {
            context: "Failed to set the 'onerror' property on 'WebSocket': The provided value"
          });
        }
        esValue[implSymbol]["onerror"] = V;
      }
    }, {
      key: "onclose",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'get onclose' called on an object that is not a valid instance of WebSocket.");
        }
        return utils.tryWrapperForImpl(esValue[implSymbol]["onclose"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'set onclose' called on an object that is not a valid instance of WebSocket.");
        }
        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(globalObject, V, {
            context: "Failed to set the 'onclose' property on 'WebSocket': The provided value"
          });
        }
        esValue[implSymbol]["onclose"] = V;
      }
    }, {
      key: "extensions",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'get extensions' called on an object that is not a valid instance of WebSocket.");
        }
        return esValue[implSymbol]["extensions"];
      }
    }, {
      key: "protocol",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'get protocol' called on an object that is not a valid instance of WebSocket.");
        }
        return esValue[implSymbol]["protocol"];
      }
    }, {
      key: "onmessage",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'get onmessage' called on an object that is not a valid instance of WebSocket.");
        }
        return utils.tryWrapperForImpl(esValue[implSymbol]["onmessage"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'set onmessage' called on an object that is not a valid instance of WebSocket.");
        }
        if (!utils.isObject(V)) {
          V = null;
        } else {
          V = EventHandlerNonNull.convert(globalObject, V, {
            context: "Failed to set the 'onmessage' property on 'WebSocket': The provided value"
          });
        }
        esValue[implSymbol]["onmessage"] = V;
      }
    }, {
      key: "binaryType",
      get: function get() {
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'get binaryType' called on an object that is not a valid instance of WebSocket.");
        }
        return utils.tryWrapperForImpl(esValue[implSymbol]["binaryType"]);
      },
      set: function set(V) {
        var esValue = this !== null && this !== undefined ? this : globalObject;
        if (!exports.is(esValue)) {
          throw new globalObject.TypeError("'set binaryType' called on an object that is not a valid instance of WebSocket.");
        }
        V = "".concat(V);
        if (!BinaryType.enumerationValues.has(V)) {
          return;
        }
        esValue[implSymbol]["binaryType"] = V;
      }
    }]);
    return WebSocket;
  }(globalObject.EventTarget);
  Object.defineProperties(WebSocket.prototype, (_Object$definePropert = {
    close: {
      enumerable: true
    },
    send: {
      enumerable: true
    },
    url: {
      enumerable: true
    },
    readyState: {
      enumerable: true
    },
    bufferedAmount: {
      enumerable: true
    },
    onopen: {
      enumerable: true
    },
    onerror: {
      enumerable: true
    },
    onclose: {
      enumerable: true
    },
    extensions: {
      enumerable: true
    },
    protocol: {
      enumerable: true
    },
    onmessage: {
      enumerable: true
    },
    binaryType: {
      enumerable: true
    }
  }, _defineProperty(_Object$definePropert, Symbol.toStringTag, {
    value: "WebSocket",
    configurable: true
  }), _defineProperty(_Object$definePropert, "CONNECTING", {
    value: 0,
    enumerable: true
  }), _defineProperty(_Object$definePropert, "OPEN", {
    value: 1,
    enumerable: true
  }), _defineProperty(_Object$definePropert, "CLOSING", {
    value: 2,
    enumerable: true
  }), _defineProperty(_Object$definePropert, "CLOSED", {
    value: 3,
    enumerable: true
  }), _Object$definePropert));
  Object.defineProperties(WebSocket, {
    CONNECTING: {
      value: 0,
      enumerable: true
    },
    OPEN: {
      value: 1,
      enumerable: true
    },
    CLOSING: {
      value: 2,
      enumerable: true
    },
    CLOSED: {
      value: 3,
      enumerable: true
    }
  });
  ctorRegistry[interfaceName] = WebSocket;
  Object.defineProperty(globalObject, interfaceName, {
    configurable: true,
    writable: true,
    value: WebSocket
  });
};
var Impl = require("../websockets/WebSocket-impl.js");